<template>

  <body>
    <div></div>
    <div class="container">
      <div class="xmain"
           style="background: #fff; padding-top: 0px;">
        <div class="wrap">
          <div class="local">
            <a href="/index.jsp">首页</a>&nbsp;>&nbsp;
            <a @click="selectRelativeCountry('')"
               href="javascript:void(0)">签证</a>
            <span v-show="param.relative_city !== ''">&nbsp;>&nbsp;{{param.relative_city}}</span>
          </div>
          <!-- 左边导航 -->
          <div class="list_leftNav">
            <div class="leftNav_top">
              <h1>签证国家/地区</h1>
              <div class="left_nav_in">
                <div v-for="(nations,index1) in this.nations_group">
                  <a @click="selectRelativeCountry(nation,$event)"
                     href="javascript:void(0);"
                     ref="actioned"
                     v-for="(nation,index2) in nations">{{nation}}</a>
                </div>
              </div>
            </div>
            <div class="leftNav_bottom">
              <h1>签证热门国家/地区</h1>
            </div>
          </div>
          <div class="list_right_con">
            <!-- 列表内容开始 -->
            <div class="list_right_list">
              <div class="list_right_paging">
                <paging :current_change="handleCurrentChange"
                        :loading="paging_load.loading"
                        :not_data="!route_info_search_param.total || route_info_search_param.total <= 0"
                        :page_size="5"
                        :total="route_info_search_param.total"
                        v-if="!isInit"
                        v-model="route_info_search_param.current">
                  <div class="list_right_list_height">
                    <visa-route-item :item="item"
                                     :key="index"
                                     v-for="(item,index) in route_list"
                                     v-if="!isInit"></visa-route-item>
                  </div>
                </paging>
              </div>
            </div>
            <!-- 列表内容结束 -->
          </div>
          <div class="clear"></div>
        </div>
      </div>
    </div>
  </body>
</template>
<script>
import VisaRouteItem from '@/pages/common/visaRouteItem.vue'
import { Paging } from '@/pages/components'
import { debug } from 'util';
export default {
  name: "VisaProduct",
  componentName: "VisaProduct",
  components: {
    VisaRouteItem,
    Paging
  },
  data () {
    return {
      local: [],
      url_name: 'visaRouteList',
      route_id: 0,
      param: {
        relative_city: ''
      },
      get_visa_nations_url: 'visa/visa_nations',
      get_part_route_url: 'route/part_route',
      route_info_search_param: {
        part_enname: 'hot_visa',
        current: 1,
        size: 5,
        relative_city: '',
        product_category: 10,
        total: 0
      },
      nations: [],
      nations_group: [],
      route_list: [],
      isInit: true, //判断页面初始化时的异步加载是否完成（由于父子组件间异步传数据，有可能子组件mounted阶段时异步加载还未完成）
      paging_load: {
        loading: true
      }
    }
  },
  created () {


    this.route_id = this.$route.query.route_id
    this.$myGet(this.get_visa_nations_url)
      .then(res => {
        this.nations = res.response.data.visa_nations
        var part_name_index = this.$route.query.part_name_index
        if (part_name_index) {
          let visaCountry = this.nations[part_name_index]
          this.$sessionStorageUtil.set('relative_city', visaCountry)
        }
        this.nationsGroup()
        //获取左边数据
        if (this.$sessionStorageUtil.get('relative_city')) {
          this.param.relative_city = this.$sessionStorageUtil.get('relative_city')
          this.route_info_search_param.relative_city = this.$sessionStorageUtil.get('relative_city')
        }
        if (this.$sessionStorageUtil.get('current_page')) {
          this.route_info_search_param.current = this.$sessionStorageUtil.get('current_page')
        }
        //获取签证产品列表
        this.paging_load.loading = true
        this.$myGet(this.get_part_route_url, this.route_info_search_param)
          .then(res => {
            this.route_list = res.response.data.route_list
            this.route_info_search_param.total = res.response.data.total
            this.paging_load.loading = false
            this.isInit = false
          })
          .catch(err => {
            this.paging_load.loading = false
            this.$msg('[' + err.status + ']' + err.message, 'error')
          })
      })
      .catch(err => {
        this.$msg('[' + err.status + ']' + err.message, 'error')
      })



  },
  methods: {
    handleCurrentChange (val) {
      this.$sessionStorageUtil.set('current_page', val, 60 * 30)
      this.getVisaProduct()
    },
    nationsGroup () {
      var array = []
      var arrayChild = []
      for (var i = 0; i < this.nations.length; i++) {
        if (i % 4 == 0) {
          arrayChild = []
          array.push(arrayChild)
        }
        arrayChild.push(this.nations[i])
      }
      this.nations_group = array
    },
    selectRelativeCountry (relative_city, e) {
      this.$sessionStorageUtil.set('relative_city', relative_city, 60 * 30)
      this.$sessionStorageUtil.set('current_page', 0)
      this.param.relative_city = relative_city
      this.route_info_search_param.current = 1
      this.route_info_search_param.relative_city = relative_city
      let obj = this.$refs.actioned
      for (var i = 0; i < obj.length; i++) {
        obj[i].classList.value = ''
        obj[i].className = ''
      }
      var e = e || window.event;
      let actions = e.srcElement ? e.srcElement : e.target;
      actions.className = "action"
      this.getVisaProduct()
    },

    internalNavigation () {
      let formInfoLocal = [];
      let temp = formInfo.get("part_enname");
      let local = temp.split("-");
      for (let i = 1; i < local.length; i++) {
        local[i] = local[i - 1] + "-" + local[i]
      }
      for (let i = 0; i < local.length; i++) {
        formInfoLocal.put("part_enname", local[i])
        partInfo = partManageBean.getPartByEnname(formInfoLocal, request)
      }
    },
    getVisaProduct () {
      this.paging_load.loading = true
      this.$myGet(this.get_part_route_url, this.route_info_search_param)
        .then(res => {
          this.route_list = res.response.data.route_list
          this.route_info_search_param.total = res.response.data.total
          this.paging_load.loading = false
        })
        .catch(err => {
          this.paging_load.loading = false
          this.$msg('[' + err.status + ']' + err.message, 'error')
        })
    },
  },
  mounted () {
  },
  loadMore () {

  },

}
</script>
<style scoped>
@import '../../assets/css/pages/html/layout.css';
@import '../../assets/css/pages/html/viasproduct.css';
</style>



// WEBPACK FOOTER //
// src/pages/common/visaProduct.vue